// Getters (GET*)
export const AUTH_IS_LOGGED = 'AUTH_IS_LOGGED';
export const AUTH_GET_USERNAME = 'AUTH_GET_USERNAME';
export const AUTH_GET_USER_FULL_NAME = 'AUTH_GET_USER_FULL_NAME';
export const AUTH_GET_VEHICLETYPE = 'AUTH_GET_VEHICLETYPE';
export const AUTH_GET_CLIENT = 'AUTH_GET_CLIENT';
export const AUTH_GET_EMAIL = 'AUTH_GET_EMAIL';
export const AUTH_GET_TOKEN = 'AUTH_GET_TOKEN';
export const IS_AUTHORIZED = 'IS_AUTHORIZED';
export const HAS_FEATURES = 'HAS_FEATURES';
export const IS_AUTH_WITH_ERROR = 'IS_AUTH_WITH_ERROR';
export const IS_MAKING_LOGIN = 'IS_MAKING_LOGIN';
export const AUTH_GET_COUNTRY = 'AUTH_GET_COUNTRY';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_WITH_ERROR = 'AUTH_ERROR';
export const AUTH_SET_MAKING_LOGIN = 'AUTH_SET_MAKING_LOGIN';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const MAKE_LOGIN = 'MAKE_LOGIN';
export const UPDATE_FLAG_MAKING_LOGIN = 'UPDATE_FLAG_MAKING_LOGIN';
